// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { withSearch } from '../traits/withSearch';
import { TableLikeVM } from './TableLikeVM';
import { action, makeObservable, override } from 'mobx';
import { handler, makeMetadata } from '../helpers/decorators';

export class SearchTableVM extends withSearch(TableLikeVM) {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  $identifierField = `id` as never;

  @handler
  @override
  onPaginationChange(pagination: { pageNo: number; pageSize: number }) {
    this.setPageSize(pagination.pageSize);
    this.setPageNo(pagination.pageNo);
    this.setQuerySchema({ page: { ...pagination, total: this.total } });
  }

  @handler
  @override
  onSelectChange(value: any) {
    this.setState({ selectedInfo: value });
  }
}
